import React, { useState, useEffect } from "react";
import { useLoading } from "../contexts/LoadingContext";
import Loader from "../components/loader";

const PreviousAppointments = () => {
  const { isLoading, setIsLoading } = useLoading();
  const [appointments, setAppointments] = useState([]);

  useEffect(() => {
    const fetchPreviousAppointments = async () => {
      setIsLoading(true);
      try {
        // Fetch implementation will go here
        await new Promise(resolve => setTimeout(resolve, 1000)); // Temporary delay
        setAppointments([]); // Will be replaced with actual data
      } catch (error) {
        console.error('Error fetching previous appointments:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPreviousAppointments();
  }, [setIsLoading]);

  if (isLoading) {
    return <Loader type="appointment" count={3} />;
  }

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col">
          <h4>Previous Appointments</h4>
          {appointments.length > 0 ? (
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Doctor</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {appointments.map((appointment) => (
                  <tr key={appointment.id}>
                    <td>{appointment.doctor}</td>
                    <td>{appointment.date}</td>
                    <td>{appointment.time}</td>
                    <td>Completed</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="text-center">No previous appointments found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default PreviousAppointments;
